// src/api/merchantInvoices.js
import api from '../services/api'

export async function fetchMerchantInvoices() {
    const res = await api.get('/merchant/invoices')
    return res.data
}

export async function createMerchantInvoice(payload) {
    const res = await api.post('/merchant/invoices', payload)
    return res.data
}

export async function fetchMerchantInvoice(id) {
    const res = await api.get(`/merchant/invoices/${encodeURIComponent(id)}`)
    return res.data
}
